module.exports = __webpack_public_path__ + "static/media/crossIcon34.0789b6da.svg";